<form [formGroup]="model" (ngSubmit)="aplicarFiltros()">
  <div class="row search-area">
    <div class="col-12 col-lg-4 search-field">
      <mat-form-field appearance="outline">
        <mat-label>Pesquisar</mat-label>
        <input matInput type="text" formControlName="pesquisa" maxlength="80" placeholder="Lote Scanntech, caixa ou ID" />
        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-8 filter-container">
      <button
        #periodoMenuTrigger="matMenuTrigger"
        mat-stroked-button
        type="button"
        class="btn-periodo"
        [matMenuTriggerFor]="periodoMenu"
        (menuOpened)="prepararPeriodoIntervalo()"
        [class.btn-periodo--ativo]="periodoSelecionado !== PeriodoEnum.SemFiltro">
        {{ periodoLabel }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
        <div class="periodo-menu-content">
          <button type="button" class="periodo-menu-item" (click)="selecionarPeriodo(PeriodoEnum.SemFiltro); aplicarPeriodo()" [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.SemFiltro">
            <span>sem filtro</span>
            @if (periodoSelecionado === PeriodoEnum.SemFiltro) { <mat-icon>check</mat-icon> }
          </button>
          <button type="button" class="periodo-menu-item" (click)="selecionarPeriodo(PeriodoEnum.Ultimos30Dias); aplicarPeriodo()" [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.Ultimos30Dias">
            <span>últimos 30 dias</span>
            @if (periodoSelecionado === PeriodoEnum.Ultimos30Dias) { <mat-icon>check</mat-icon> }
          </button>
          <button type="button" class="periodo-menu-item" (click)="selecionarPeriodo(PeriodoEnum.DoMes); aplicarPeriodo()" [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoMes">
            <span>do mês</span>
            @if (periodoSelecionado === PeriodoEnum.DoMes) { <mat-icon>check</mat-icon> }
          </button>
          <button type="button" class="periodo-menu-item" (click)="selecionarPeriodo(PeriodoEnum.DoIntervalo); $event.stopPropagation()" [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoIntervalo">
            <span>do intervalo</span>
            @if (periodoSelecionado === PeriodoEnum.DoIntervalo) { <mat-icon>check</mat-icon> }
          </button>

          @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
            <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
              <mat-form-field appearance="outline">
                <mat-label>De</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerPeriodoDe"
                  [(ngModel)]="periodoIntervaloDe"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onPeriodoIntervaloChange('de', $event)"
                  (input)="onDateInput($event)"
                  (keydown)="onDateKeydown($event)"
                  (blur)="onDateBlur($event, 'de')"
                  placeholder="DD/MM/AAAA"
                  inputmode="numeric"
                  maxlength="10"
                  [max]="periodoIntervaloAte" />
                <mat-datepicker-toggle matSuffix [for]="pickerPeriodoDe"></mat-datepicker-toggle>
                <mat-datepicker #pickerPeriodoDe></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Até</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerPeriodoAte"
                  [(ngModel)]="periodoIntervaloAte"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="onPeriodoIntervaloChange('ate', $event)"
                  (input)="onDateInput($event)"
                  (keydown)="onDateKeydown($event)"
                  (blur)="onDateBlur($event, 'ate')"
                  placeholder="DD/MM/AAAA"
                  inputmode="numeric"
                  maxlength="10"
                  [min]="periodoIntervaloDe" />
                <mat-datepicker-toggle matSuffix [for]="pickerPeriodoAte"></mat-datepicker-toggle>
                <mat-datepicker #pickerPeriodoAte></mat-datepicker>
              </mat-form-field>

              <div class="periodo-intervalo-actions">
                <button type="button" mat-button class="btn-secondary" (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">Cancelar</button>
                <button type="button" mat-flat-button class="btn-primary" (click)="aplicarPeriodo(periodoMenuTrigger)">Aplicar</button>
              </div>
            </div>
          }
        </div>
      </mat-menu>

      <button
        #filtrosAvancadosMenuTrigger="matMenuTrigger"
        mat-stroked-button
        type="button"
        class="btn-filter"
        [matMenuTriggerFor]="filtroMenu"
        [matBadge]="qtdFiltrosAvancados"
        [matBadgeHidden]="qtdFiltrosAvancados === 0">
        <mat-icon>filter_list</mat-icon>
        Filtrar
      </button>

      <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
        <div class="filter-menu-content" [formGroup]="model" (click)="$event.stopPropagation()">
          <h6>Filtros Avançados</h6>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Caixa</mat-label>
            <input matInput formControlName="caixa" inputmode="numeric" maxlength="12" (keydown)="onNumberKeydown($event)" (blur)="onNumberBlur('caixa')" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Status</mat-label>
            <mat-select formControlName="statusIntegracaoScanntech">
              @for (op of statusOptions; track op.value) {
                <mat-option [value]="op.value">{{ op.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="filter-menu__actions">
            <button type="button" mat-button class="btn-secondary" matMenuClose (click)="filtrosAvancadosMenuTrigger.closeMenu()">Cancelar</button>
            <button type="button" mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>Aplicar</button>
          </div>
        </div>
      </mat-menu>

      <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
        <mat-icon>cleaning_services</mat-icon>
        Limpar Filtros
      </button>

      <button mat-stroked-button type="button" class="btn-filter desktop-view" (click)="configurarColunas()">
        <mat-icon>view_column</mat-icon>
        Configurar Colunas
      </button>
    </div>
  </div>
</form>

@if (_isLoading && _dataSource.data.length === 0) {
  <app-loading-box-default-list></app-loading-box-default-list>
} @else if (_dataSource.data.length === 0) {
  <app-empty-list [title]="'Nenhum fechamento encontrado'" [subTitle]="'Ajuste os filtros para refinar a busca'"></app-empty-list>
} @else {
  <table mat-table class="desktop-view tabela-integracao" [dataSource]="_dataSource" matSort>
    <ng-container matColumnDef="selecao">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="alternarTodos()" [checked]="isTodosSelecionados()"></mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <span class="checkbox-tooltip-wrapper" [matTooltip]="getHintSelecao(row)" [matTooltipDisabled]="podeSelecionar(row)">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="selecao.toggle(row.idSomatorioFechamentoDiario)"
            [checked]="selecao.isSelected(row.idSomatorioFechamentoDiario)"
            [disabled]="!podeSelecionar(row)">
          </mat-checkbox>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="dataVenda">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dataVenda">Data venda</th>
      <td mat-cell *matCellDef="let row">{{ row.dataVenda | date: 'dd/MM/yyyy' }}</td>
    </ng-container>

    <ng-container matColumnDef="caixa">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="caixa">Caixa</th>
      <td mat-cell *matCellDef="let row">{{ row.caixa }}</td>
    </ng-container>

    <ng-container matColumnDef="idLoteScanntech">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="idLoteScanntech">Lote Scanntech</th>
      <td mat-cell *matCellDef="let row">{{ row.idLoteScanntech || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="valorTotalVendaLiquida">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="valorTotalVendaLiquida">Venda líquida</th>
      <td mat-cell *matCellDef="let row" class="text-end">{{ row.valorTotalVendaLiquida | currency: 'BRL' }}</td>
    </ng-container>

    <ng-container matColumnDef="valorTotalVendaCancelada">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="valorTotalVendaCancelada">Venda cancelada</th>
      <td mat-cell *matCellDef="let row" class="text-end">{{ row.valorTotalVendaCancelada | currency: 'BRL' }}</td>
    </ng-container>

    <ng-container matColumnDef="quantidadeVendaEnviada">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="quantidadeVendaEnviada">Qtd. vendas</th>
      <td mat-cell *matCellDef="let row" class="text-end">{{ row.quantidadeVendaEnviada }}</td>
    </ng-container>

    <ng-container matColumnDef="quantidadeVendaCanceladaEnviada">
      <th mat-header-cell *matHeaderCellDef class="text-end" mat-sort-header="quantidadeVendaCanceladaEnviada">Qtd. canceladas</th>
      <td mat-cell *matCellDef="let row" class="text-end">{{ row.quantidadeVendaCanceladaEnviada }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
      <td mat-cell *matCellDef="let row">
        <span [class]="getStatusBadgeClass(row.statusIntegracaoScanntech)">
          {{ getStatusLabel(row.statusIntegracaoScanntech) }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="ultimoErro">
      <th mat-header-cell *matHeaderCellDef>Último erro</th>
      <td mat-cell *matCellDef="let row">
        @if (row.ultimaMensagemLog) {
          <span class="texto-truncado" [matTooltip]="row.ultimaMensagemLog">{{ row.ultimoCodigoErroScanntech || row.ultimaMensagemLog }}</span>
        } @else {
          <span>-</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="datetimeInclusao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="datetimeInclusao">Inclusão</th>
      <td mat-cell *matCellDef="let row">{{ row.datetimeInclusao | date: 'dd/MM/yyyy HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="acoes">
      <th mat-header-cell *matHeaderCellDef class="text-end w-actions">Ações</th>
      <td mat-cell *matCellDef="let row" class="text-end w-actions">
        <button mat-icon-button [matMenuTriggerFor]="menuRow" aria-label="Ações">
          <span class="material-symbols-outlined">more_horiz</span>
        </button>
        <mat-menu #menuRow="matMenu">
          @if (podeHabilitarReprocessamento(row)) {
            <button mat-menu-item (click)="marcarLinhaReprocessamento(row)">
              <mat-icon>sync</mat-icon>
              <span>Habilitar reprocessamento</span>
            </button>
          }
          @if (podeDesabilitarReprocessamento(row)) {
            <button mat-menu-item (click)="desmarcarLinhaReprocessamento(row)">
              <mat-icon>close</mat-icon>
              <span>Desabilitar reprocessamento</span>
            </button>
          }
          <button mat-menu-item (click)="verLogs(row.idSomatorioFechamentoDiario)">
            <mat-icon>list_alt</mat-icon>
            <span>{{ idLogsCarregando === row.idSomatorioFechamentoDiario ? 'Carregando logs...' : 'Exibir logs' }}</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <div class="mobile-view mobile-list">
    @for (row of _dataSource.data; track row.idSomatorioFechamentoDiario) {
      <div class="mobile-card">
        <div class="mobile-card__header">
          <span class="checkbox-tooltip-wrapper" [matTooltip]="getHintSelecao(row)" [matTooltipDisabled]="podeSelecionar(row)">
            <mat-checkbox (change)="selecao.toggle(row.idSomatorioFechamentoDiario)" [checked]="selecao.isSelected(row.idSomatorioFechamentoDiario)" [disabled]="!podeSelecionar(row)"></mat-checkbox>
          </span>
          <div>
            <strong>{{ row.dataVenda | date: 'dd/MM/yyyy' }}</strong>
            <span>Caixa {{ row.caixa }}</span>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="mobileMenu" aria-label="Ações">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #mobileMenu="matMenu">
            @if (podeHabilitarReprocessamento(row)) {
              <button mat-menu-item (click)="marcarLinhaReprocessamento(row)">
                <mat-icon>sync</mat-icon>
                <span>Habilitar reprocessamento</span>
              </button>
            }
            @if (podeDesabilitarReprocessamento(row)) {
              <button mat-menu-item (click)="desmarcarLinhaReprocessamento(row)">
                <mat-icon>close</mat-icon>
                <span>Desabilitar reprocessamento</span>
              </button>
            }
            <button mat-menu-item (click)="verLogs(row.idSomatorioFechamentoDiario)">
              <mat-icon>list_alt</mat-icon>
              <span>{{ idLogsCarregando === row.idSomatorioFechamentoDiario ? 'Carregando logs...' : 'Exibir logs' }}</span>
            </button>
          </mat-menu>
        </div>
        <div class="mobile-card__body">
          <span><strong>Lote Scanntech:</strong> {{ row.idLoteScanntech || '-' }}</span>
          <span><strong>Venda líquida:</strong> {{ row.valorTotalVendaLiquida | currency: 'BRL' }}</span>
          <span><strong>Venda cancelada:</strong> {{ row.valorTotalVendaCancelada | currency: 'BRL' }}</span>
          <span><strong>Qtd. vendas:</strong> {{ row.quantidadeVendaEnviada }}</span>
          <span [class]="getStatusBadgeClass(row.statusIntegracaoScanntech)">{{ getStatusLabel(row.statusIntegracaoScanntech) }}</span>
        </div>
      </div>
    }
  </div>

  @if (!_ultimaPagina) {
    <div class="col-12 text-center ver-mais-pesquisa">
      <span class="button-tooltip-wrapper" [matTooltip]="getHintVerMais()" [matTooltipDisabled]="!_isLoading">
        <button mat-button class="btn-ver-mais" [disabled]="_isLoading" (click)="proximaPagina()">
          @if (_isLoading) {
            <mat-spinner diameter="18"></mat-spinner>
          } @else {
            <span class="material-symbols-outlined">expand_more</span>
          }
          Ver Mais
        </button>
      </span>
    </div>
  }
}
